import { render, staticRenderFns } from "./programacion-transferencia.vue?vue&type=template&id=2bdefb30"
import script from "./programacion-transferencia.vue?vue&type=script&lang=ts"
export * from "./programacion-transferencia.vue?vue&type=script&lang=ts"
import style0 from "./programacion-transferencia.vue?vue&type=style&index=0&id=2bdefb30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports